/**
 * DASHBOARD-RPS-GOLLAC
 * Burnout indicators
 */

import Space from "@/components/space"
import { t } from "i18next"
import DashboardHeatmapWidget from "./dashboard-heatmap.widget"
import { useState } from "react"
import GollacInfoHelp from "@/help/gollac-info.help"
import Button from "@/components/button"
import Card from "@/components/card"
import { useNavigate } from "react-router-dom"
import { useAppSelector } from "@/core/root-reducer"
import { AccountHeatmapResult } from "@/redux/account.types"

interface Props {
  isReport?: boolean
  isPreview?: boolean
  limit?: number
  offset?: number
  isFirstPage?: boolean
  resultsType?: AccountHeatmapResult
}

export const DashboardRpsGollacWidget = (props: Props) => {
  const navigate = useNavigate()

  // selectors
  const _session = useAppSelector((state) => state._session)

  // states
  const [showHelp, setShowHelp] = useState<boolean>(false)

  // functions
  const handleModalOpen = () => {
    setShowHelp(true)
  }

  const handleModalClose = () => {
    setShowHelp(false)
  }

  const handleAdminLinkClick = () => {
    navigate("/adm/settings")
  }

  // render
  return (
    <>
      {/* Show Card with title only if not in report or if first page */}
      {(!props.isReport || props.isFirstPage !== false) && (
        <Card title={t("rps_users_gap")}>
          {_session.accountOptions.gollacFilterName && _session.accountOptions.gollacManagerAttributeName ? (
            <div>
              {/* Show description only on first page */}
              {props.isFirstPage !== false && (
                <div className="p-1">
                  <p className="text-idt-grey-darker text-base leading-relaxed">
                    {t("golac_heatmap_info")}
                    {!props.isReport && (
                      <span className="link text-idt-grey-dark inline cursor-pointer" onClick={handleModalOpen}>
                        {t("faq_calculation")}...
                      </span>
                    )}
                  </p>
                </div>
              )}

              {/* Show table on non-first pages in report */}
              {!(props.isReport && props.isFirstPage === false) && (
                <DashboardHeatmapWidget
                  isGollac={true}
                  isReport={props.isReport ?? undefined}
                  isPreview={props.isPreview}
                  limit={props.limit}
                  offset={props.offset}
                  resultsType={props.resultsType}
                />
              )}
            </div>
          ) : (
            <div className="m-2 flex items-center">
              <b>
                {t("filter_reference_manager_gollac")} : {t("utils_undefined")}{" "}
              </b>
              <Space />
              {_session.userRole === "ADMIN" ? (
                <Button onClick={handleAdminLinkClick}>{t("adm_filter_route")}</Button>
              ) : (
                <div>{t("contact_admin")}</div>
              )}
            </div>
          )}
        </Card>
      )}

      {/* Show only table (no Card) if in report and not first page */}
      {props.isReport &&
        props.isFirstPage === false &&
        _session.accountOptions.gollacFilterName &&
        _session.accountOptions.gollacManagerAttributeName && (
          <DashboardHeatmapWidget
            isGollac={true}
            isReport={props.isReport ?? undefined}
            isPreview={props.isPreview}
            limit={props.limit}
            offset={props.offset}
            hideHeader={true}
            skipFirstRow={true}
            resultsType={props.resultsType}
          />
        )}
      {showHelp && <GollacInfoHelp onClose={() => handleModalClose()} />}
    </>
  )
}
